// Input component index constants
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;
export const THIRD_INDEX = 2;
export const FOURTH_INDEX = 3;

// Padding and formatting constants
export const PAD_START = 2;
export const MONTH_SLICE_INDEX = 7;
